import { withRtlSupport } from '@skyscanner-internal/backpack-web/bpk-component-icon';
import LongArrowLeftIcon from '@skyscanner-internal/backpack-web/bpk-component-icon/lg/long-arrow-left';
import { BpkModalV3, MODAL_V3_TYPES } from '@skyscanner-internal/backpack-web/bpk-component-modal';
import BpkText, { TEXT_STYLES } from '@skyscanner-internal/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';
import { useTranslations } from '@web-platform/shared-travel-tools-utils-frontend';

import { OriginAutosuggest } from '../OriginAutosuggest/OriginAutosuggest';

import type { CityItem } from '@web-platform/travel-tools-flight-price-map-utils-frontend';

import STYLES from './OriginAutosuggestModal.module.scss';

const cls = cssModules(STYLES);

const LongArrowLeftIconWithRtl = withRtlSupport(LongArrowLeftIcon);

type OriginAutosuggestModalProps = {
  cities: CityItem[];
  countryName?: string;
  countrySlug: string;
  inputPlaceholder?: string;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (city: CityItem) => void;
};

export const OriginAutosuggestModal = ({
  cities,
  countryName,
  countrySlug,
  inputPlaceholder,
  isOpen,
  onClose,
  onSelect,
}: OriginAutosuggestModalProps) => {
  const { translate } = useTranslations();

  const handleSelect = (city: CityItem) => {
    onSelect(city);
    onClose();
  };

  return (
    <BpkModalV3.Root
      open={isOpen}
      type={MODAL_V3_TYPES.full}
      onOpenChange={({ open }) => !open && onClose()}
    >
      <BpkModalV3.Scrim />
      <BpkModalV3.Portal>
        <BpkModalV3.Content>
          <BpkModalV3.Header>
            <div className={cls('header')}>
              <button
                aria-label={translate('travel_confidence_map_back')}
                className={cls('backButton')}
                onClick={onClose}
                type="button"
              >
                <LongArrowLeftIconWithRtl />
              </button>
              <BpkText tagName="h2" textStyle={TEXT_STYLES.heading5} className={cls('title')}>
                {translate('travel_confidence_map_where_from')}
              </BpkText>
            </div>
          </BpkModalV3.Header>
          <BpkModalV3.Body>
            <OriginAutosuggest
              autoFocus={isOpen}
              cities={cities}
              countryName={countryName}
              countrySlug={countrySlug}
              inputPlaceholder={inputPlaceholder}
              isMobile
              onClose={onClose}
              onSelect={handleSelect}
            />
          </BpkModalV3.Body>
        </BpkModalV3.Content>
      </BpkModalV3.Portal>
    </BpkModalV3.Root>
  );
};
